import script from "./FlatSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./FlatSpinner.vue?vue&type=style&index=0&id=3a797da2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a797da2"]])

export default __exports__